function Spinner({
  size = "default",
  className = "",
}: {
  size?: "small" | "default" | "large";
  className?: string;
}) {
  const sizeClasses = {
    small: "w-6 h-6 border-2",
    default: "w-10 h-10 border-4",
    large: "w-16 h-16 border-4",
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`${sizeClasses[size]} border-t-transparent border-blue-600 rounded-full animate-spin mx-auto`}
      />
    </div>
  );
}

export default Spinner;
